import React from 'react';
import emptyImage from '@assets/imgs/empty.png';

export function SearchEmpty() {
  return (
    <div className="flex flex-col items-center justify-center my-8 gap-8">
      <img src={emptyImage} alt="" className="w-[10rem] h-[8.5rem]" />
      <div className="text-t3 text-sm font-normal">No search result !</div>
    </div>
  );
}
